import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies)
import { Search,Collapse, CollapseItem, Pagination, Swipe, SwipeItem, Icon, Tag, List, Cell, DropdownMenu, DropdownItem ,Grid, GridItem ,Tab, Tabs ,Form ,Field ,Button ,Popup  ,Picker,NavBar ,Checkbox, CheckboxGroup  } from 'vant';
Vue.use(Search).use(Pagination).use(Button).use(Picker).use(Popup).use(Swipe).use(SwipeItem).use(Icon).use(Tag).use(List).use(Cell).use(DropdownMenu).use(DropdownItem).use(Grid).use(GridItem).use(Tab).use(Tabs).use(Form).use(Field).use(NavBar)
.use(Checkbox)
.use(CheckboxGroup)
.use(Collapse)
.use(CollapseItem);
